import { useField } from "formik";
import React from "react";
import styled from "styled-components";
import { Input } from "./Input";

export const Label = styled.label`
  display: block;
  color: #fff;
  font-family: var(--altFontFamily);
  margin-bottom: 4px;
`;
const TextFieldContainer = styled.div`
  margin-bottom: 8px;
`;
const ErrorMessage = styled.div`
  color: var(--error);
  height: 24px;
  line-height: 24px;
`;
export const TextField: React.FC<
  { label: string; name: string } & React.ComponentPropsWithoutRef<typeof Input>
> = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <TextFieldContainer>
      <Label htmlFor={props.id}>{label}</Label>
      <Input data-error={meta.error ? "" : undefined} {...field} {...props} />
      <ErrorMessage>{meta.touched && meta.error}</ErrorMessage>
    </TextFieldContainer>
  );
};
